import React, { useEffect, useRef, useState } from "react";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const AcsiScoringParameters = () => {

    const [parameterList, setParameterList] = useState<any[]>([]);
    const [questList, setQuestList] = useState<any[]>([]);
    const [listOfQuestions, setListOfQuestions] = useState<any[]>([]);
    const [name, setName] = useState("");
    const [parameterId, setParameterId] = useState("");
    const [description, setDescription] = useState("");
    const [minScore, setMinScore] = useState("");
    const [maxScore, setMaxScore] = useState("");
    const [interpretation, setInterpretation] = useState("");
    const [parameterStatus, setParameterStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchAcsiScoringParameters();
    }, [])

    async function fetchAcsiScoringParameters() {
        setIsLoading(true);
        const parametersResponse = await func.acsiScoringParameters(null);
        setParameterList(Array.isArray(parametersResponse) ? parametersResponse : [])
        setIsLoading(false);
    }

    const filteredData = parameterList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.name}</span>;
    };

    const descriptionRender = (rowData) => {
        return <span>{rowData.description}</span>;
    };

    const relatedQuestionRender = (rowData) => {
        return <span>{rowData.related_questions}</span>;
    };

    const minScoreRender = (rowData) => {
        return <span>{rowData.min_score}</span>;
    };

    const maxScoreRender = (rowData) => {
        return <span>{rowData.max_score}</span>;
    };

    const interpretationRender = (rowData) => {
        return <span>{rowData.interpretation}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };

    async function newAcsiScoringParameters() {
        const questResponse = await func.acsiQuestions(null);
        setListOfQuestions(Array.isArray(questResponse) ? questResponse : [])
        setIsEdit(false);
        setOpenModal(true);
        setName("");
        setDescription("");
        setQuestList([]);
        setMinScore("");
        setMaxScore("");
        setInterpretation("");
        setParameterStatus("");
    }

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editAcsiScoringParameters(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const parameterId = rowData.id;
        return (
            <Link to="#" onClick={() => deleteAcsiScoringParameters(parameterId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editAcsiScoringParameters(rowData: { id: any; }) {
        const paramId = rowData.id;
        const questResponse = await func.acsiQuestions(null);
        setListOfQuestions(Array.isArray(questResponse) ? questResponse : [])
        const paramResponse = await func.acsiScoringParameters(paramId);
        setParameterId(paramResponse.id);
        setName(paramResponse.name);
        setDescription(paramResponse.description);
        const relatedQuestionIds = paramResponse.related_questions
            ? paramResponse.related_questions
                .split(",")
                .map((id: string) => Number(id.trim()))
                .filter((id: number) => !isNaN(id))
            : [];

        setQuestList(relatedQuestionIds);
        // setQuestList(paramResponse.related_questions);
        setMinScore(paramResponse.min_score);
        setMaxScore(paramResponse.max_score);
        setInterpretation(paramResponse.interpretation);
        setParameterStatus(paramResponse.status);
        setIsEdit(true)
        setOpenModal(true)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateAcsiScoringParameters();
            } else {
                const formData = new FormData();
                formData.append("name", name);
                formData.append("description", description);
                formData.append("related_questions", JSON.stringify(questList));
                formData.append("min_score", minScore);
                formData.append("max_score", maxScore);
                formData.append("interpretation", interpretation);

                const createParameters = api.AcsiScoringParameters;
                fetch(createParameters, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchAcsiScoringParameters();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    function updateAcsiScoringParameters() {
        const formData = new FormData();
        formData.append("name", name);
        formData.append("description", description);
        formData.append("related_questions", JSON.stringify(questList));
        formData.append("min_score", minScore);
        formData.append("max_score", maxScore);
        formData.append("interpretation", interpretation);
        formData.append("status", parameterStatus);

        const updateQuest = api.AcsiScoringParameters + '/' + parameterId;
        fetch(updateQuest, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchAcsiScoringParameters();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteAcsiScoringParameters(questparamId: string) {
        const deleteQuest = api.AcsiScoringParameters + '/' + questparamId + '/' + 0;
        fetch(deleteQuest, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchAcsiScoringParameters();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Acsi Scoring Parameters</h4>
                                    {/* {currentPermissions.includes("add") ? */}
                                    <Link
                                        to="#"
                                        className="btn"
                                        onClick={() => { newAcsiScoringParameters() }}
                                        data-bs-toggle="tooltip"
                                        style={{ fontSize: "24px", padding: "0px" }}
                                        title="Create Scoring Parameters">
                                        <i className="feather-plus" />&nbsp;
                                    </Link>
                                    {/* : null
                                    } */}
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="name"
                                                header="Name"
                                                body={nameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="description"
                                                header="Description"
                                                body={descriptionRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="related_questions"
                                                header="Questions"
                                                body={relatedQuestionRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="minScore"
                                                header="Minimum Score"
                                                body={minScoreRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="maxScore"
                                                header="Maximum Score"
                                                body={maxScoreRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="interpretation"
                                                header="Interpretation"
                                                body={interpretationRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {/* {currentPermissions.includes("edit") ? */}
                                            <Column
                                                className="text-link"
                                                body={editDetails}
                                            ></Column>
                                            {/*  : null
                                            }
                                            {currentPermissions.includes("delete") ? */}
                                            <Column
                                                className="text-link"
                                                body={deleteDetails}
                                            ></Column>
                                            {/*   : null
                                        // */}
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                centered
                size="md"
                show={openModal}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} ACSI Scoring Parameters</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    placeholder="Enter Name"
                                    required
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Description</label>
                                <textarea
                                    className="form-control"
                                    rows={3}
                                    placeholder="Enter Description"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Related Questions</label>
                                <Select
                                    isMulti
                                    value={Array.isArray(listOfQuestions)
                                        ? listOfQuestions
                                            .filter(quest => questList.includes(Number(quest.questionId)))
                                            .map(quest => ({
                                                value: Number(quest.questionId),
                                                label: quest.question_text
                                            }))
                                        : []
                                    }
                                    styles={customSelect}
                                    required
                                    onChange={(selectedOptions) => {
                                        const selectedIds = Array.isArray(selectedOptions)
                                            ? selectedOptions.map(option => option.value)
                                            : selectedOptions
                                                ? [selectedOptions.value]
                                                : [];
                                        setQuestList(selectedIds);
                                    }}
                                    options={Array.isArray(listOfQuestions)
                                        ? listOfQuestions.map(quest => ({
                                            value: Number(quest.questionId),
                                            label: quest.question_text
                                        }))
                                        : []
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Minimum Score</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    placeholder="Enter Minimum Score"
                                    required
                                    value={minScore}
                                    onChange={(e) => setMinScore(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Maximum Score</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    placeholder="Enter Maximum Score"
                                    required
                                    value={maxScore}
                                    onChange={(e) => setMaxScore(e.target.value)}
                                />
                            </div>
                        </div> <div className="col-lg-12 mb-10">
                            <div className="input-space">
                                <label className="form-label">Interpretation</label>
                                <textarea
                                    className="form-control"
                                    rows={3}
                                    placeholder="Enter Interpretation"
                                    value={interpretation}
                                    onChange={(e) => setInterpretation(e.target.value)}
                                />
                            </div>
                        </div>
                        {isEdit ?
                            <>
                                <div className="row">
                                    <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                        <label className="form-label">Status</label>
                                    </div>
                                    <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                        <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                            <input
                                                className="form-check-input text-end"
                                                type="checkbox"
                                                checked={parameterStatus === '1'}
                                                id="answerStatus"
                                                onChange={(e) => {
                                                    setParameterStatus(e.target.checked ? '1' : '0')
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </> : null
                        }
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default AcsiScoringParameters;